export const selectRankings = (state: any, competitionCode: string, queryField: string) => {
    const opta = state.opta;
    const teamRankings: any = opta.teamRankings;
    const assistsRankings: any = opta.assistsRankings;
    const scorerRankings: any = opta.scorerRankings;

    if (queryField === 'league') {
        return { teamRankings: teamRankings?.[competitionCode] || [] }
    }

    if (queryField === 'player') {
        return {
            assistsRankings: assistsRankings?.[competitionCode] || [],
            scorerRankings: scorerRankings?.[competitionCode] || [],
        }
    }

    return {
        teamRankings: teamRankings?.[competitionCode] || [],
        assistsRankings: assistsRankings?.[competitionCode] || [],
        scorerRankings: scorerRankings?.[competitionCode] || [],
    }
}